export const nodeType = (type) => {
  switch (type) {
    case 12:
      return 'initialNode';
    case 2:
      return 'messageNode';
    case 9:
      return 'questionNode';
    case 1:
      return 'responseAINode';
    case 3:
      return 'imageNode';
    case 4:
      return 'videoNode';
    case 5:
      return 'documentNode';
    case 10:
      return 'conditionNode';
    case 11:
      return 'endNode';
    case 6:
      return 'formNode';
    case 7:
      return 'carouselNode';
    case 8:
      return 'captureNode';
    case 13:
      return 'redirectNode';
    case 14:
      return 'dataAINode';
  }
};
